import { OperatingSystem } from '@capacitor/device';

import { CMSAppRatings } from '@/interfaces/cms';

export const digestAppRatings = ({
  cmsAppRatings,
  deviceOS,
  isMobileApp,
}: {
  cmsAppRatings?: CMSAppRatings;
  deviceOS?: OperatingSystem;
  isMobileApp: boolean;
}) => {
  if (!cmsAppRatings || isMobileApp) return undefined;

  const appRatings: { iOS?: number; android?: number } = {
    iOS: Number(cmsAppRatings?.iOS),
    android: Number(cmsAppRatings?.android),
  };

  if (!deviceOS) return {};

  const iosWeb = deviceOS === 'ios';
  const androidWeb = deviceOS === 'android';
  const otherWeb = !iosWeb && !androidWeb;

  if (otherWeb) return appRatings;
  if (iosWeb) delete appRatings.android;
  if (androidWeb) delete appRatings?.iOS;

  return appRatings;
};
